import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';

/**
 * The nodes of an organisation's certification tree. There is deliberately no unscoped collection
 * GET on this resource — the whole tree is read through
 * `organisation_profiles/{id}/certification_nodes` (see OrganisationProfileApiService).
 */
@Injectable({
  providedIn: 'root'
})
export class OrganisationProfileCertificationNodeApiService extends ApiService {
  readonly resourcePath = 'organisation_profile_certification_nodes';

  get(id: string): Observable<any> {
    return this.restRead<any>(id);
  }

  create(data: object): Observable<any> {
    return this.restCreate<any>(data);
  }

  update(id: string, data: object): Observable<any> {
    return this.restUpdate<any>(id, data);
  }

  delete(id: string): Observable<null> {
    return this.restDelete(id);
  }
}
